import { cn } from "~/lib/utils";

export function Wordmark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "font-heading text-base font-bold tracking-tight",
        className,
      )}
    >
      <span className="text-sidebar-accent">Alfred</span>
    </span>
  );
}
